import React from 'react';
import { Col, Row, Alert } from 'reactstrap';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { Button } from 'antd';
import { column1, column2, ndaAcceptance } from './formConfig';
import './EditOrganization.scss';
import { editQuote } from '../../../pages/contractQuote/graphql';

export default class EditQuote extends React.PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    initialValues: PropTypes.shape({
      id: PropTypes.string,
      comment: PropTypes.string,
      deliveryDate: PropTypes.string,
      ndaAccept: PropTypes.string,
      q_machiningReq: PropTypes.string,
      q_qty: PropTypes.string,
      q_sampleAvailable: PropTypes.string,
      q_toolingAvailable: PropTypes.string,
      q_toolingDesc: PropTypes.string,
      shipping: PropTypes.string,
      status: PropTypes.string,
      unitPrice: PropTypes.string,
    }),
    totalCost: PropTypes.string,

    alertType: PropTypes.string.isRequired,
    alertMessage: PropTypes.string.isRequired,
    changeDate: PropTypes.func.isRequired,
    ndaObj: PropTypes.object.isRequired,
    viewPDF: PropTypes.func.isRequired,
    readOnly: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    initialValues: {
      comment: '',
      deliveryDate: '',
      ndaAccept: null,
      q_machiningReq: null,
      q_qty: null,
      q_sampleAvailable: null,
      q_toolingAvailable: null,
      q_toolingDesc: null,
      q_comment: null,
      shipping: null,
      status: '',
      unitPrice: null,
    },
    totalCost: 0,
  };

  static initialState = {
    showModal: false,
  };

  state = editQuote.initialState;

  addTotalCost = () => {
    const values = { ...this.props.initialValues };
    values.totalCost = this.props.totalCost;
    console.log(values);
    return values;
  };

  render() {
    const {
      onSubmit,
      initialValues,
      alertType,
      alertMessage,
      changeDate,
      ndaObj,
      viewPDF,
      readOnly,
    } = this.props;
    console.log(ndaObj);
    return (
      <Form
        onSubmit={onSubmit}
        initialValues={this.addTotalCost(initialValues)}
        render={({ handleSubmit }) => (
          <form className="nf-edit-rfq-form" onChange={handleSubmit}>
            <br />
            {alertMessage && <Alert color={alertType}>{alertMessage}</Alert>}

            <div>
              <Row>
                <Col>
                  {column1.map(fieldConfig => (
                    <Field
                      key={fieldConfig.name}
                      disabled={readOnly}
                      {...fieldConfig}
                      changeDate={changeDate}
                    />
                  ))}
                </Col>
                <Col>
                  {column2.map(fieldConfig => (
                    <Field
                      key={fieldConfig.name}
                      {...fieldConfig}
                      changeDate={changeDate}
                      disabled={readOnly}
                    />
                  ))}

                  {ndaObj.value &&
                    ndaObj.value !== '0' && (
                      <div>
                        <Field
                          key={ndaAcceptance.name}
                          {...ndaAcceptance}
                          changeDate={changeDate}
                          disabled={readOnly}
                        />
                        <Row>
                          <Col xs={3} />
                          <Col>
                            <Button onClick={viewPDF} disabled={readOnly}>
                              {' '}
                              View {ndaObj.display}
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    )}
                  {/* <Field
                    key={Comments.name}
                    {...Comments}
                    changeDate={changeDate}
                    disabled={readOnly}
                  /> */}
                </Col>
              </Row>
            </div>
          </form>
        )}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/EditQuoteForm/EditQuote.jsx